import { lazy } from 'react'

export const PageAtlasGruzoviePerevozkiAsync = lazy(() => import('./page_atlas_gruzovie-perevozki'))
